import * as React from 'react'
import styled from 'styled-components'
import { withRouter } from 'react-router-dom'

import Layout from '../../../../components/ui/Layout/Layout'
import ActionButton from '../../../../components/ui/ActionButton/ActionButton'

const Title = styled.h1`
  font-family: var(--font-family-ayala-display-sans);
  font-size: 1.5rem;
  text-align: center;
  margin-top: 0;
  color: var(--color-secondary);
  font-weight: var(--font-weight-boldest);
`
const Description = styled.p`
  text-align: center;
`
const ButtonWrapper = styled.div`
  margin: 2rem 0 0;
`
const StyledButton = styled(ActionButton)`
  width: 100%;
`

function MainView(props) {
  const { history } = props

  const handleClick = () => {
    console.log('Account Deletion - Back to Home page')
    history.replace('/')
  }

  return (
    <Layout {...props}>
      <Title>See you Around!</Title>
      <Description>
        <p>
          Your request has been submitted. Your account will be deleted within
          3-5 business days.
        </p>
        {/* <p>
          We have successfully deleted your account. Don’t worry, you can still
          register again using the same credentials in the future.
        </p> */}
        <p>
          Don’t miss out on any Ayala Malls happening by visiting&nbsp;
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.ayalamalls.com"
          >
            www.ayalamalls.com
          </a>
          .
        </p>
      </Description>
      <ButtonWrapper>
        <StyledButton variant="primary" onClick={handleClick}>
          Back to homepage
        </StyledButton>
      </ButtonWrapper>
    </Layout>
  )
}

MainView.defaultProps = {}

MainView.propTypes = {}

export default withRouter(MainView)
